import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { authGuard } from '#/auth';

import addInitialLoadRequiredRuleToRouter from '#/routes/rules/initial-load';
import addAllowedToTestRuleToRouter from '#/routes/rules/allowed-to-test';
import addWorkspaceRequiredRuleToRouter from '#/routes/rules/workspace-required';
import addProjectRequiredRuleToRouter from '#/routes/rules/project-required';
import addOnboardRequiredRuleToRouter from '#/routes/rules/onboard-required';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// all routes are authGuarded requiring user login.
router.beforeEach((to, from, next) => authGuard(to, from, next));

// rule to check user token may_test / may_beta flags if the site is deployed as test/beta mode.
// check flags prior to initial-load because initial-load will fail if these flags are missing when required.
addAllowedToTestRuleToRouter(router);

// initial-load required
addInitialLoadRequiredRuleToRouter(router);

// rule to check if the user needs to be onboarded
addOnboardRequiredRuleToRouter(router);

// rule to check if workspace query param is required for this route.
addWorkspaceRequiredRuleToRouter(router);

// rule to check if project query param is required for this route.
addProjectRequiredRuleToRouter(router);

// TODO: rule to check if user has perms to the workspace or project page - reroute to perm denied if missing
// ->>> example of setting a root load error ->>>
// router.beforeEach((to, from, next) => {
//   store.commit('setErrorOnLoad', {
//     error: 'This is a sample error message',
//   });
// });

export default router;
